if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.autoExtend = this.dataset.autoExtend === 'true';
      this.repeatDays = parseInt(this.dataset.days, 10) || 0;

      // Initialize end date
      this._initEndDate();

      if (!this.endDate || isNaN(this.endDate)) {
        console.warn('CountdownTimer: Invalid endDate');
        return;
      }

      // Cache display elements
      this._initElements();

      // Start timer
      this._startTimer();
    }

    _getNow() {
      return new Date().getTime();
    }

    _initEndDate() {
      const rawDate = this.dataset.endDate || '';
      const rawTime = this.dataset.endTime || '00:00';
      
      // Parse date in YYYY-MM-DD format (avoid timezone issues)
      const dateParts = rawDate.split('-');
      if (dateParts.length !== 3) {
        console.warn('CountdownTimer: Invalid date format. Use YYYY-MM-DD');
        return;
      }
      
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Months are 0-indexed
      const day = parseInt(dateParts[2], 10);
      
      // Parse time in HH:MM format
      const timeParts = rawTime.split(':');
      const hours = parseInt(timeParts[0], 10) || 0;
      const minutes = parseInt(timeParts[1], 10) || 0;
      
      // Create date object without timezone conversion
      const end = new Date(year, month, day, hours, minutes, 0, 0);
      
      this.originalEndDate = end.getTime();
      this.endDate = this._calculateNextOccurrence();
    }

    _calculateNextOccurrence() {
      const now = this._getNow();
      
      // If not repeating or date is in future, use original date
      if (!this.autoExtend || this.repeatDays <= 0 || this.originalEndDate > now) {
        return this.originalEndDate;
      }
      
      // Calculate how many intervals have passed since the original date
      const timePassed = now - this.originalEndDate;
      const intervalMs = this.repeatDays * 24 * 60 * 60 * 1000;
      const intervalsPassed = Math.floor(timePassed / intervalMs) + 1;
      
      // Return the next occurrence
      return this.originalEndDate + (intervalsPassed * intervalMs);
    }

    _initElements() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');
    }

    _startTimer() {
      this._update();
      this.interval = setInterval(() => this._update(), 1000);
    }

    _update() {
      const now = this._getNow();
      let diff = this.endDate - now;

      // If countdown finished and we're repeating, calculate next occurrence
      if (diff <= 0 && this.autoExtend && this.repeatDays > 0) {
        this.endDate = this._calculateNextOccurrence();
        diff = this.endDate - now;
      }

      // If countdown finished and not repeating
      if (diff <= 0) {
        this._setDisplay(0, 0, 0, 0);
        if (!this.autoExtend || this.repeatDays <= 0) {
          clearInterval(this.interval);
        }
        return;
      }

      const days = Math.floor(diff / (24 * 60 * 60 * 1000));
      const hours = Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      const mins = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
      const secs = Math.floor((diff % (60 * 1000)) / 1000);

      this._setDisplay(days, hours, mins, secs);
    }

    _setDisplay(d, h, m, s) {
      if (this.daysEl) this.daysEl.textContent = d;
      if (this.hoursEl) this.hoursEl.textContent = h.toString().padStart(2, '0');
      if (this.minsEl) this.minsEl.textContent = m.toString().padStart(2, '0');
      if (this.secsEl) this.secsEl.textContent = s.toString().padStart(2, '0');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}